// Theme helper — sinkronkan dark mode untuk Tailwind (class `dark` pada <html>)
// dan template admin SCSS (class `dark-theme` pada <body>).
//
// Kita pakai 1 key localStorage: `color-theme` (konsisten dengan App.vue).

const STORAGE_KEY = "color-theme";

export type ColorTheme = "light" | "dark";

export function getStoredTheme(): ColorTheme | null {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === "dark" || v === "light" ? v : null;
}

export function resolveInitialTheme(): ColorTheme {
  const stored = getStoredTheme();
  if (stored) return stored;
  if (typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
}

export function applyTheme(theme: ColorTheme, persist = true): void {
  const html = document.documentElement;
  const body = document.body;
  if (theme === "dark") {
    html.classList.add("dark");
    body?.classList.add("dark-theme");
  } else {
    html.classList.remove("dark");
    body?.classList.remove("dark-theme");
  }
  if (persist) {
    localStorage.setItem(STORAGE_KEY, theme);
  }
}

export function toggleTheme(): ColorTheme {
  const next: ColorTheme = document.documentElement.classList.contains("dark") ? "light" : "dark";
  applyTheme(next);
  return next;
}

export function isDarkTheme(): boolean {
  return document.documentElement.classList.contains("dark");
}
